import { CCAddress } from '../../models';
import { CCData } from '../../models';
import { SexEnum } from '../../models';
import { ClientData } from '../../models';

const pretifyText = (text: string) => text.trim().toLowerCase()
    .split(' ')
    .map(s => s.length <= 2 ? s : s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');

const mapAddress = (cc: CCAddress): Pick<ClientData, 'addressLine1'|'addressLine2'|'city'> => ({
    addressLine1: pretifyText(`${cc.streetType} ${cc.streetName}, N${cc.doorNo} ${cc.floor} ${cc.side}`),
    addressLine2: pretifyText([cc.place, cc.locality].join(', ')),
    city: pretifyText(cc.district),
});

export const mapClientData = (cc?: CCData): Omit<ClientData, 'id'>|undefined => {
    if (!cc) return undefined;
    return {
        name: pretifyText(cc.givenName + ' ' + cc.surname),
        sex: cc.gender === 'M' ? SexEnum.Male : SexEnum.Female,
        healthNumber: cc.healthNumber,
        taxNumber: cc.taxNo,
        identificationNumber: cc.documentNumber,
        birthday: `${cc.dateOfBirth.slice(6, 10)}-${cc.dateOfBirth.slice(3, 5)}-${cc.dateOfBirth.slice(0, 2)}`,
        height: Number.parseFloat(cc.height.replace(',', '.')),
        photo: cc.photo as unknown as string,
        ...(cc.address ? mapAddress(cc.address) : {}),
    }
}
